module.exports = __webpack_public_path__ + "static/img/chanyefuwu.ff7b041.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/chanyefuwu.png
// module id = gS0C
// module chunks = 1